import React from 'react'
import PropTypes from 'prop-types'
import { Skeleton as AntSkeleton } from 'antd'
import { classNames } from 'utils/utils'

const Skeleton = ({ className, loading, rows, width, children }) => (
  <AntSkeleton
    className={classNames(className, 'skeleton')}
    active
    paragraph={{
      rows,
      width,
    }}
    title={false}
    avatar={false}
    loading={loading}
  >
    {children}
  </AntSkeleton>
)

Skeleton.defaultProps = {
  rows: 1,
}

Skeleton.propTypes = {
  /** Make sure to comment */
  /** Classname */
  className: PropTypes.string,
  /** child components */
  children: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.element,
    PropTypes.number,
  ]),
  /** boolean, determines whether the skeleton is displayed or not */
  loading: PropTypes.bool,
  /** Number of rows to display */
  rows: PropTypes.number,
  /** as string or number, width of single or last row, as array, width of each row */
  width: PropTypes.arrayOf(
    PropTypes.oneOfType([PropTypes.string, PropTypes.number])
  ),
}

export default Skeleton
